import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from '@bibliocommons/base-links';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';

import './SuggestForPurchaseInfo.scss';

export default function SuggestForPurchaseInfo({ message }) {
  const currentLibrary = useSelector(selectCurrentLibrary);
  const premiumEnabled = currentLibrary.getIn(['suggestForPurchase', 'premium', 'enabled']);

  return (
    <div className="cp-suggest-for-purchase-info">
      <div className="suggest-for-purchase-message">{message}</div>
      {premiumEnabled && (
        <Link block dataKey="suggested-purchases-link" href="/suggested_purchases">
          <FormattedMessage id="view_suggested_purchases" />
        </Link>
      )}
    </div>
  );
}

SuggestForPurchaseInfo.propTypes = {
  message: PropTypes.node.isRequired
};
